
import Api from './api'
import Package from '../../package'

export default {

    healthCheck: function () {

        return Api.get(`/health/device/web/version/${ Package.version }`)

    }
}
